var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"svgContainer",staticClass:"w-full bg-[#FCFCFC] rounded-lg p-4",domProps:{"innerHTML":_vm._s(_vm.svg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }